import { StyledArticle,StyledContent } from "@/components/styles";
import { ArrowButton, Picture } from "@/components";
import genLinkParams from "@/lib/generateLinkParams";
import Link from "next/link";

export default function Article(props) {
  const { title, date, preview_text:desc, preview: imageFromProps,preview_alt, slug, articleType = "article", ...otherProps } = props;
  const [href, as] = genLinkParams({ type: articleType, slug });

  const image = imageFromProps || {};
  const imageAlt = preview_alt || title || '';

  return (
    <StyledArticle {...otherProps}>
      <Link href={href} as={as} passHref>
        <StyledArticle.Link />
      </Link>

      <StyledArticle.Bg />

      <StyledArticle.Img>{Object.keys(image).length > 0 && <Picture {...image} alt={imageAlt} isLazy={true}/>}</StyledArticle.Img>

      <StyledArticle.Content>
        {date && <StyledArticle.Date>{date}</StyledArticle.Date>}

        {desc && (
          <StyledArticle.Desc>
            <StyledContent.Html>{desc}</StyledContent.Html>
          </StyledArticle.Desc>
        )}
        <StyledArticle.Title>{title}</StyledArticle.Title>
        <StyledArticle.Arrow>
          <ArrowButton />
        </StyledArticle.Arrow>
      </StyledArticle.Content>
    </StyledArticle>
  );
}
